// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type { IAddRequest, TAddModel, IMappers, TAddResponse, IAddResponse } from './types';

export const defaultConfig: TAddModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'files',
  pathApi: '/v1/add/',
  requestType: 'formData',
} as TAddModel;

export function createAddModel(parameters: IAddRequest): TAddModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IAddRequest;
}

export async function fetchAdd<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddOptions<TResponse200>): Promise<TAddResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createAddModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TAddResponse;
}
